var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "prelative" },
    [
      _c("preloader", {
        staticClass: "loader-small",
        attrs: { display: _vm.loader }
      }),
      _vm._v(" "),
      _c("toggle-card", {
        attrs: { display: !_vm.loader, data: _vm.cardDatas }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }